module.exports = __webpack_public_path__ + "static/img/dw.1df964c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dw.png
// module id = p51E
// module chunks = 0